import { useQuery } from "@tanstack/react-query";

import API, { GetScenesQuery } from "../api";

function useScenes({
  selectedDates,
  bbox,
  subResource= "",
}: GetScenesQuery) {
  const { isPending, error, data, refetch } = useQuery({
    queryKey: ["scenes", bbox?.join(","), selectedDates.join(","), subResource],
    queryFn: () => API.getScenes({ selectedDates, bbox, subResource }),
    refetchInterval: 5 * 60 * 1000 // Refesh data every 5 minutes
  });

  return {
    isLoading: isPending,
    error,
    scenes: data,
    refetch
  };
}

export default useScenes;
